import React, { useEffect, useState, useCallback } from "react";
import Table from "../../common/Table/table";
import AddUpdateModal from "./AddUpdateModal";
import ViewModal from "./ViewModal";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { useDispatch, useSelector } from "react-redux";
import {
  createPatientData,
  getAllPatient,
  resetMessage,
  resetUpdateMessages,
  updatePatientSlice,
  resetDeleteMessages,
  deletePatientSlice,
  getPatientIdSlice,
} from "../../../store/slices/patientSlice";
import { getCitySlice } from "../../../store/slices/citySlice";
import {
  showToastifySuccess,
  showToastifyError,
} from "../../common/tostify/Toastifyresponse";
import ShowTostifyMessageAndReset from "../../common/showTostifyMessageAndReset/showTostifyMessageAndReset";
import { useNavigate } from "react-router-dom";
import { getCountrySlice } from "../../../store/slices/countrySlice";
import { getStateSlice } from "../../../store/slices/state";
import { Col, Row } from "react-bootstrap";
import AdharRegistration from "./AbhaRegistration/AdharRegistration";
import styles from "./AbhaRegistration/AdharRegistrartion.module.scss";
import AdhaarImg from "../../../../src/images/PatientRegistrationImages/adhar.webp";
import { FaPhoneSquareAlt, FaSearch } from "react-icons/fa";
import { MdAppRegistration } from "react-icons/md";
import { IoQrCodeOutline } from "react-icons/io5";
import { getDistricSlice } from "../../../store/slices/districtSlice";
import Verification from "./AbhaRegistration/Verification";
import ScanAndShare from "./AbhaRegistration/ScanAndShare";
import FindAbha from "./AbhaRegistration/FindAbha";

const Patientlist = () => {
  const dispatch = useDispatch();
  const { userDetails, adharOtpGenerateMsg, loading } = useSelector(
    (state) => state.abhaRegistration,
  );
  const { districts } = useSelector((state) => state.district);
  const showTostifyMessageAndReset = ShowTostifyMessageAndReset();
  const { userInfo, token } = useSelector((state) => state.auth);
  const [showRegistrationModal, setShowRegistrationModal] = useState(false);
  const [showAdharRegistration, setShowAdharRegistration] = useState(false);
  const [showMobileRegistration, setShowMobileRegistration] = useState(false);
  const [showScanAndShare, setShowScanAndShare] = useState(false);
  const [showFindAbha, setShowFindAbha] = useState(false);
  const { clinicInfo } = useSelector((state) => state.clinic);
  const [modalVisible, setModalVisible] = useState(false);
  const [viewModal, setViewModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [isUpdateMode, setIsUpdateMode] = useState(false);
  const [selectedPatient, setSelectedPatient] = useState(null);
  const [searchValue, setSearchValue] = useState("");
  const [aadharNumber, setAadharNumber] = useState("");
  const [pageLimit, setPageLimit] = useState(10);

  const {
    patients,
    successMessage,
    updateErrorMessage,
    updateSuccessMessage,
    deleteErrorMessage,
    deleteSuccessMessage,
    searchMessage,
    patientErrorMessage,
    currentPage,
    totalPages,
    totalCount,
    isLoading,
  } = useSelector((state) => state.patient);

  const [fieldErrors, setFieldErrors] = useState({});
  const { patientData } = useSelector((state) => state.patient);
  const { cities } = useSelector((state) => state.city);
  const { Country } = useSelector((state) => state.country);
  const { state } = useSelector((state) => state.state);
  const navigate = useNavigate();
  const clinicId = clinicInfo?.[0]?.clinicId || null;
  const [formData, setFormData] = useState({
    clinicId: "",
    clinicUserId: "",
    title: "",
    name: "",
    email: "",
    phone: "",
    alternate_Phone: "",
    userType: 1,
    gender: "",
    age: {
      year: null,
      month: null,
      day: null,
    },
    city: "",
    cityName: "",
    country: "",
    countryName: "",
    state: "",
    stateName: "",
    district: "",
    districtName: "",
    dob: "",
    address: "",
    pin: "",
    HC_number: "",
    aadhar_number: "",
    passport: "",
    blood_group: "",
    status: "Active",
    membership_group: "",
    patient_image: "",
    abhaNumber: "",
    abhaAddress: "",
  });
  const [inputError, setInputError] = useState({
    name: false,
    email: false,
    phNumber: false,
    passport: false,
    aadhar: false,
  });
  if (!userInfo || !userInfo._id) {
    navigate("/login");
  }
  useEffect(() => {
    dispatch(getCountrySlice({ status: ["Active"], token }));
  }, [dispatch, deleteModal, viewModal, modalVisible, token]);

  const fetchPatients = useCallback(
    (page = 1, lim = pageLimit, search = searchValue) => {
      if (!clinicId || !token) return;

      dispatch(
        getAllPatient({
          patientAssociationId: clinicId,
          searchQuery: search,
          currentPage: page,
          limit: lim,
          token,
        }),
      );
    },
    [dispatch, clinicId, token, pageLimit, searchValue],
  );

  useEffect(() => {
    setFormData((prev) => ({
      ...prev,
      clinicId,
      clinicUserId: userInfo?._id,
      userType: 1,
    }));

    fetchPatients(1, pageLimit, searchValue);
  }, [fetchPatients, userInfo, clinicId]);

  const handlePageChange = (page) => {
    fetchPatients(page, pageLimit, searchValue);
  };

  const handleLimitChange = (newLimit) => {
    setPageLimit(newLimit);
    fetchPatients(1, newLimit, searchValue);
  };

  useEffect(() => {
    showTostifyMessageAndReset(
      successMessage,
      showToastifySuccess,
      resetMessage,
    );
    showTostifyMessageAndReset(
      patientErrorMessage,
      showToastifyError,
      resetMessage,
    );
    showTostifyMessageAndReset(
      updateSuccessMessage,
      showToastifySuccess,
      resetUpdateMessages,
    );
    showTostifyMessageAndReset(
      updateErrorMessage,
      showToastifyError,
      resetMessage,
    );
    showTostifyMessageAndReset(
      deleteSuccessMessage,
      showToastifySuccess,
      resetDeleteMessages,
    );
    showTostifyMessageAndReset(
      deleteErrorMessage,
      showToastifyError,
      resetDeleteMessages,
    );
  }, [
    patientErrorMessage,
    successMessage,
    dispatch,
    updateSuccessMessage,
    updateErrorMessage,
    deleteSuccessMessage,
    deleteErrorMessage,
    showTostifyMessageAndReset,
  ]);
  const tableHead = [
    { title: "Name", key: "name" },
    { title: "UHID", key: "uhid" },
    { title: "Email", key: "email" },
    { title: "Phone", key: "phone" },
    { title: "gender", key: "gender" },
  ];

  const titleOptions = [
    { value: "Miss", label: "Miss" },
    { value: "Mrs.", label: "Mrs." },
    { value: "Mr.", label: "Mr." },
    { value: "Ms.", label: "Ms." },
    { value: "Master", label: "Master" },
    { value: "Dr.", label: "Dr." },
    { value: "Prof.", label: "Prof." },
    { value: "Baby of.", label: "Baby of." },
  ];

  const Genderoptions = [
    { value: "Male", label: "Male" },
    { value: "Female", label: "Female" },
    { value: "TransGender", label: "TransGender" },
  ];

  const BloodGroupOptions = [
    { value: "A+", label: "A+" },
    { value: "A-", label: "A-" },
    { value: "B+", label: "B+" },
    { value: "B-", label: "B-" },
    { value: "O+", label: "O+" },
    { value: "O-", label: "O-" },
    { value: "AB+", label: "AB+" },
    { value: "AB-", label: "AB-" },
  ];

  const MembershipOptions = [
    { value: "General", label: "General" },
    { value: "Gold", label: "Gold" },
    { value: "Silver", label: "Silver" },
  ];

  const handleEdit = (item) => {
    setFormData({
      id: item?.id,
      clinicId,
      clinicUserId: userInfo?._id,
      title: item?.userId?.title || item?.title || "",
      name: item?.name,
      email: item?.email,
      phone: item?.phone,
      alternate_Phone: item?.alternate_Phone,
      city: item?.city || "",
      cityName: item?.cityName || "",
      country: item?.country || "",
      countryName: item?.countryName || "",
      state: item?.state || "",
      stateName: item?.stateName || "",
      district: item?.district || "",
      districtName: item?.districtName || "",
      address: item?.address,
      pin: item?.pin,
      gender: item?.gender,
      userType: 1,
      age: item?.age,
      dob: item?.dob ? new Date(item?.dob).toISOString().split("T")[0] : "",
      HC_number: item?.HC_number,
      aadhar_number: item?.aadhar_number,
      passport: item?.passport,
      blood_group: item?.blood_group,
      membership_group: item?.membership_group,
      patient_image: item?.patient_image,
      abhaNumber: item?.abhaNumber,
      abhaAddress: item?.abhaAddress,
    });
    setIsUpdateMode(true);
    setModalVisible(true);
  };
  const handlemodal = () => {
    setIsUpdateMode(false);
    setShowRegistrationModal(true);
  };
  const resetForm = () => {
    setFormData({
      clinicId,
      clinicUserId: userInfo?._id,
      userType: 1,
      title: "",
      name: "",
      email: "",
      phone: "",
      alternate_Phone: "",
      city: "",
      cityName: "",
      country: "",
      countryName: "",
      state: "",
      stateName: "",
      address: "",
      pin: "",
      gender: "",
      age: "",
      dob: "",
      HC_number: "",
      aadhar_number: "",
      passport: "",
      blood_group: "",
      membership_group: "",
      patient_image: "",
      abhaNumber: "",
      abhaAddress: "",
    });
    setIsUpdateMode(false);
  };
  const handleAdharRegistrationClick = async () => {
    setShowAdharRegistration(true);
    setShowMobileRegistration(false);
    setShowScanAndShare(false);
    setShowFindAbha(false);
  };

  const handleMobileRegistrationClick = async () => {
    try {
      setShowMobileRegistration(true);
      setShowAdharRegistration(false);
      setShowScanAndShare(false);
      setShowFindAbha(false);
    } catch (error) {
      console.error("Error in fetching ABHA credentials:", error);
    }
  };
  const handleBackToMainModal = () => {
    setShowAdharRegistration(false);
    setShowMobileRegistration(false);
    setShowScanAndShare(false);
    setShowFindAbha(false);
  };

  const handleScanAndShareClick = () => {
    setShowScanAndShare(true);
    setShowAdharRegistration(false);
    setShowMobileRegistration(false);
    setShowFindAbha(false);
  };

  const handleFindAbhaClick = () => {
    setShowFindAbha(true);
    setShowAdharRegistration(false);
    setShowMobileRegistration(false);
    setShowScanAndShare(false);
  };

  const handleSearch = (e) => {
    const value = e.target.value;
    setSearchValue(value);
    fetchPatients(1, pageLimit, value);
  };

  const handleShowGlobalViewModal = (patientDetails) => {
    dispatch(getPatientIdSlice({ patientId: patientDetails?.id, token }));
    setViewModal(true);
  };
  const handleDelete = async (item) => {
    setDeleteModal(true);
    setSelectedPatient(item);
  };

  const handleDeletePatient = async () => {
    try {
      await dispatch(
        deletePatientSlice({
          clinicId,
          patientId: selectedPatient?.id,
          token,
        }),
      );
      setDeleteModal(false);
      await dispatch(getAllPatient({ patientAssociationId: clinicId, token }));
    } catch (err) {
      console.error(err);
    }
  };
  const handleChange = (e) => {
    if (e.dob && e.age) {
      setFormData((prev) => ({
        ...prev,
        dob: e.dob,
        age: e.age,
      }));
    } else {
      const { name, value } = e.target;
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const handleSelectChange = async (selectedOption, name) => {
    if (name === "country") {
      setFormData((prevData) => ({
        ...prevData,
        country: selectedOption.value,
        countryName: selectedOption.label,
        state: "",
        stateName: "",
        district: "",
        districtName: "",
        city: "",
        cityName: "",
      }));
      await dispatch(getStateSlice({ countryId: selectedOption.value, token }));
    } else if (name === "state") {
      setFormData((prevData) => ({
        ...prevData,
        state: selectedOption.value,
        stateName: selectedOption.label,
        district: "",
        districtName: "",
        city: "",
        cityName: "",
      }));
      await dispatch(getDistricSlice({ stateId: selectedOption.value, token }));
    } else if (name === "district") {
      setFormData((prevData) => ({
        ...prevData,
        district: selectedOption.value,
        districtName: selectedOption.label,
        city: "",
        cityName: "",
      }));
      await dispatch(
        getCitySlice({
          countryId: formData.country,
          stateId: formData.state,
          districtId: selectedOption.value,
          token,
        }),
      );
    } else if (name === "city") {
      setFormData((prevData) => ({
        ...prevData,
        city: selectedOption.value,
        cityName: selectedOption.label,
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: selectedOption.value,
      }));
    }
  };

  const handleFileChange = (file) => {
    if (file) {
      setFormData((prevData) => ({
        ...prevData,
        patient_image: file,
      }));
    }
  };
  const handleAddPatient = async (e) => {
    e.preventDefault();
    const { name, email, phNumber, aadhar, passport } = inputError;
    if (name || email || phNumber || aadhar || passport) {
      return;
    }
    if (!formData.phone && !formData.alternate_Phone) {
      showToastifyError(
        "Please enter at least one mobile number (Mobile or Alternate Mobile)",
      );

      setFieldErrors((prev) => ({
        ...prev,
        phone: "Required",
        alternate_Phone: "Required",
      }));

      return;
    }
    const requiredFields = ["gender", "country", "state", "district", "city"];
    const errors = {};

    requiredFields.forEach((field) => {
      if (!formData[field]) {
        errors[field] = `Please select ${field}`;
      }
    });

    if (Object.keys(errors).length > 0) {
      setFieldErrors(errors);
      return;
    }
    try {
      const formDataToSend = new FormData();
      formDataToSend.append("clinicId", clinicId);
      formDataToSend.append("clinicUserId", formData?.clinicUserId);
      formDataToSend.append("title", formData?.title || "");
formDataToSend.append("name", formData?.name || "");
      if (formData?.email && formData?.email.trim() !== "") {
        formDataToSend.append("email", formData.email.trim());
      } else if (isUpdateMode) {
        formDataToSend.append("email", "");
      }
      if (formData?.phone) {
        formDataToSend.append("phone", formData.phone);
      }
      formDataToSend.append("alternate_Phone", formData?.alternate_Phone || "");
      formDataToSend.append("userType", formData?.userType);
      formDataToSend.append("gender", formData?.gender || "");
      formDataToSend.append("dob", formData?.dob || "");
      formDataToSend.append("HC_number", formData?.HC_number || "");
      formDataToSend.append("aadhar_number", formData?.aadhar_number || "");
      formDataToSend.append("passport", formData?.passport || "");
      formDataToSend.append("blood_group", formData?.blood_group || "");
      formDataToSend.append("status", formData?.status || "");
      formDataToSend.append(
        "membership_group",
        formData?.membership_group || "",
      );
      formDataToSend.append("country", formData?.country || "");
      formDataToSend.append("state", formData?.state || "");
      formDataToSend.append("city", formData?.city || "");
      formDataToSend.append("district", formData?.district || "");
      formDataToSend.append("pin", formData?.pin || "");
      formDataToSend.append("address", formData?.address || "");
      formDataToSend.append("day", formData?.age?.day || "");
      formDataToSend.append("month", formData?.age?.month || "");
      formDataToSend.append("year", formData?.age?.year || "");
      formDataToSend.append("abhaNumber", formData?.abhaNumber || "");
      formDataToSend.append("abhaAddress", formData?.abhaAddress || "");
      if (formData.patient_image) {
        formDataToSend.append("patient_image", formData?.patient_image);
      }
      if (isUpdateMode) {
        formDataToSend.append("patientId", formData?.id);
        await dispatch(updatePatientSlice({ formDataToSend, token }));
      } else {
        await dispatch(createPatientData({ formDataToSend, token }));
      }
      fetchPatients(currentPage || 1, pageLimit, searchValue);
      setModalVisible(false);
      setShowRegistrationModal(false);
      setIsUpdateMode(false);
    } catch (error) {
      console.error("Error details:", error);
    }
  };

  const handelProfile = (item) => {
    sessionStorage.setItem("id", item?.id);
    navigate("/patientProfile");
  };

  return (
    <>
      <Table
        tableHead={tableHead}
        tableBody={
          patients &&
          patients?.map((item) => ({
            id: item?._id,
           name: `${item?.userId?.title || ""} ${item?.userId?.name || ""}`.trim(),
            email: item?.userId?.email,
            gender: item?.userId?.gender,
            phone: item?.userId?.phone,
            country: item?.userId?.country?._id,
            countryName: item?.userId?.country?.name,
            city: item?.userId?.city?._id,
            cityName: item?.userId?.city?.name,
            state: item?.userId?.state?._id,
            stateName: item?.userId?.state?.name,
            district: item?.userId?.district?._id,
            districtName: item?.userId?.district?.name,
            HC_number: item?.userId?.HC_number,
            aadhar_number: item?.userId?.aadhar_number,
            passport: item?.userId?.passport,
            blood_group: item?.userId?.blood_group,
            membership_group: item?.userId?.membership_group,
            address: item?.userId?.address,
            pin: item?.userId?.pin,
            alternate_Phone: item?.userId?.alternate_Phone,
            dob: item?.userId?.dob,
            age: item?.userId?.age,
            uhid: item?.UHID,
            abhaNumber: item?.userId?.abhaNumber,
            abhaAddress: item?.userId?.abhaAddress,
          }))
        }
        addModal={handlemodal}
        handleSearch={handleSearch}
        searchValue={searchValue}
        handleEdit={handleEdit}
        errorMessage={searchMessage}
        handleDelete={handleDelete}
        handleShowGlobalViewModal={handleShowGlobalViewModal}
        handleAddBtn={true}
        hideStatusTab={true}
        handelProfile={handelProfile}
        currentPage={currentPage}
        totalPages={totalPages}
        totalCount={totalCount}
        limit={pageLimit}
        onPageChange={handlePageChange}
        onLimitChange={handleLimitChange}
        showPagination={true}
        showLimitDropdown={true}
        showPaymentStatusTab={false}
        isLoading={isLoading}
      />
      {modalVisible && (
        <AddUpdateModal
          setModalVisible={setModalVisible}
          modalVisible={modalVisible}
          formData={formData}
          handleAddPatient={handleAddPatient}
          setFormData={setFormData}
          handleChange={handleChange}
          bloodGroupOptions={BloodGroupOptions}
          membershipOptions={MembershipOptions}
          genderOptions={Genderoptions}
          handleSelectChange={handleSelectChange}
          isUpdateMode={isUpdateMode}
          setIsUpdateMode={setIsUpdateMode}
          titleOptions={titleOptions}
          cities={cities}
          Country={Country}
          state={state}
          setInputError={setInputError}
          handleFileChange={handleFileChange}
          userDetails={userDetails}
          districts={districts}
          token={token}
          dispatch={dispatch}
          resetForm={resetForm}
          aadharNumber={aadharNumber}
          fieldErrors={fieldErrors}
          setFieldErrors={setFieldErrors}
        />
      )}
      <ViewModal
        viewModal={viewModal}
        setViewModal={setViewModal}
        patientData={patientData}
      />
      <Modal
        show={showRegistrationModal}
        onHide={() => {
          setShowAdharRegistration(false);
          setShowRegistrationModal(false);
          setShowMobileRegistration(false);
          setShowScanAndShare(false);
          setShowFindAbha(false);
        }}
        size="xl"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {showAdharRegistration
              ? "Adhar Registration"
              : showFindAbha
                ? "Find ABHA"
                : showScanAndShare
                  ? "Scan and Share"
                  : "Patient Registration"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {showAdharRegistration ? (
            <AdharRegistration
              onBack={handleBackToMainModal}
              clinicId={clinicId}
              clinicName={clinicInfo?.[0]?.clinicName}
              setModalVisible={setModalVisible}
              setShowRegistrationModal={setShowRegistrationModal}
              adharOtpGenerateMsg={adharOtpGenerateMsg}
              loading={loading}
              setAadharNumber={setAadharNumber}
            />
          ) : showMobileRegistration ? (
            <Verification
              onBack={handleBackToMainModal}
              clinicId={clinicId}
              clinicName={clinicInfo?.[0]?.clinicName}
              setModalVisible={setModalVisible}
              setShowRegistrationModal={setShowRegistrationModal}
              setShowMobileRegistration={setShowMobileRegistration}
              setAadharNumber={setAadharNumber}
              setShowAdharRegistration={setShowAdharRegistration}
              loading={loading}
            />
          ) : showFindAbha ? (
            <FindAbha
              clinicId={clinicId}
              setModalVisible={setModalVisible}
              setShowRegistrationModal={setShowRegistrationModal}
              onBack={handleBackToMainModal}
            />
          ) : showScanAndShare ? (
            <ScanAndShare
              clinicId={clinicId}
              clinicName={clinicInfo?.[0]?.clinicName}
              setModalVisible={setModalVisible}
              setShowRegistrationModal={setShowRegistrationModal}
              onBack={handleBackToMainModal}
            />
          ) : (
            <Row className="justify-content-center">
              <Col md={6} lg={2}>
                <div
                  onClick={handleAdharRegistrationClick}
                  className={styles.regCard}
                >
                  <img src={AdhaarImg} alt="adhaar" />
                  <h5>
                    Go With <span>Abha </span> Registration
                  </h5>
                </div>
              </Col>
              <Col md={6} lg={2}>
                <div
                  onClick={handleMobileRegistrationClick}
                  className={styles.regCard}
                >
                  <FaPhoneSquareAlt />
                  <h5>
                    Go With <span>Abha</span> Verification
                  </h5>
                </div>
              </Col>
              <Col md={6} lg={2}>
                <div
                  onClick={handleScanAndShareClick}
                  className={styles.regCard}
                >
                  <IoQrCodeOutline />
                  <h5>
                    Go With <span>Scan & Share</span>
                  </h5>
                </div>
              </Col>
              <Col md={6} lg={2}>
                <div onClick={handleFindAbhaClick} className={styles.regCard}>
                  <FaSearch />
                  <h5>
                    Go With <span>Find ABHA</span>
                  </h5>
                </div>
              </Col>
              <Col md={6} lg={2}>
                <div
                  onClick={() => {
                    resetForm();
                    dispatch({ type: "CLEAR_USER_DETAILS" });
                    setShowRegistrationModal(false);
                    setShowScanAndShare(false);
                    setShowFindAbha(false);
                    setModalVisible(true);
                  }}
                  className={styles.regCard}
                >
                  <MdAppRegistration />
                  <h5>
                    Go With <span>Patient </span> Registration
                  </h5>
                </div>
              </Col>
            </Row>
          )}
        </Modal.Body>
        <Modal.Footer></Modal.Footer>
      </Modal>
      <Modal centered show={deleteModal} onHide={() => setDeleteModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Are You Sure Want to delete it?</Modal.Title>
        </Modal.Header>
        <Modal.Body>Please Delete It Carefully</Modal.Body>
        <Modal.Footer>
          <Button
            variant="primary"
            onClick={() => setDeleteModal(false)}
            className="p-2"
          >
            Cancel
          </Button>
          <Button
            variant="danger"
            onClick={handleDeletePatient}
            className="p-2"
          >
            Delete
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default Patientlist;
